import { ChangeDetectorRef, Component, DestroyRef, HostBinding, Input, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';
import { Store } from '@ngrx/store';
import { Observable, distinctUntilChanged } from 'rxjs';

import { IBetslipRootState } from '../../../base/store/state';
import { OverAskFlowState } from '../../../model/over-ask/over-ask';
import { overAskFlowStateSelector } from '../selectors';

@Component({
    template: '',
    standalone: false,
})
export class BetslipOverAskBaseComponent implements OnInit {
    @HostBinding('class.betslip-over-ask') cls = true;

    @HostBinding('class.betslip-over-ask--hidden')
    get isHidden(): boolean {
        return this.flowState === OverAskFlowState.None;
    }

    @Input() oddsDisplayFormat: OddsDisplayFormat;

    OverAskFlowState = OverAskFlowState;
    readonly overAskFlowState$: Observable<OverAskFlowState>;
    flowState: OverAskFlowState = OverAskFlowState.None;
    private readonly destroyRef = inject(DestroyRef);

    constructor(
        store: Store<IBetslipRootState>,
        private changeDetector: ChangeDetectorRef,
    ) {
        this.overAskFlowState$ = store.select(overAskFlowStateSelector);
    }

    ngOnInit(): void {
        this.overAskFlowState$.pipe(distinctUntilChanged(), takeUntilDestroyed(this.destroyRef)).subscribe((flowState) => {
            this.flowState = flowState;
            this.changeDetector.markForCheck();
        });
    }
}
